import React from 'react';
import styled from 'styled-components';
import MapPreview from '@component/common/map-preview';
import TextBlock from '@component/common/block/text-block';
import Gap from '@component/common/gap';
import type { IMapPreviewModalData } from '@datatype/gridgio/type';
import * as color from '@constant/color';
import * as size from '@constant/size';

interface IProps {
  data: IMapPreviewModalData['data'];
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const MapPreviewContainer = styled.div`
  width: 75vw;
  height: 70vh;
  overflow: hidden;
  border-radius: ${size.BORDER_RADIUS_1};
`;

const MapPreviewModal: React.FC<IProps> = ({ data }) => (
  <Wrapper>
    <TextBlock text='지도 미리보기' design={{ text: { size: 'large', color: color.BLACK_2, bold: true } }} />
    <MapPreviewContainer>
      <MapPreview latitude={data.latitude} longitude={data.longitude} />
    </MapPreviewContainer>
  </Wrapper>
);

export default MapPreviewModal;
